import { styled } from "@mui/material/styles"
import { Box, Typography } from "@mui/material"
import { Container } from "../"

interface SubPageHeaderProps {
  title: string
  description: string
  breadcrumbs: { title: string; uri?: string }[]
}

const SubPageHeader = ({ title, description, breadcrumbs }: SubPageHeaderProps) => {
  return (
    <Container maxWidth={1560} sx={{ mt: { xs: 20, md: 37 } }}>
      {breadcrumbs.length > 0 && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      <HeaderContainer>
        <Typography
          dangerouslySetInnerHTML={{ __html: title }}
          component="h1"
          variant="heading.3xl"
          sx={{
            fontSize: "56px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "110%",
            letterSpacing: "-1.12px",
          }}
        />
        <Typography
          dangerouslySetInnerHTML={{ __html: description }}
          component="p"
          variant="body.lg"
          sx={{
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "170%",
            letterSpacing: "-0.128px",
            alignSelf: "end",
          }}
        />
      </HeaderContainer>
    </Container>
  )
}

export default SubPageHeader

const HeaderContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "40px",
  width: "100%",
  padding: theme.spacing(21, 6, 13),

  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    gap: theme.spacing(2),
    padding: theme.spacing(5, 3),
  },
}))

const BreadcrumbSeparator = () => (
  <Typography
    component="span"
    variant="body.sm"
    sx={{
      color: "neutral.700.main",
      mx: 1,
    }}
  >
    /
  </Typography>
)

const Breadcrumbs = ({ breadcrumbs }: { breadcrumbs: Array<{ title: string; uri?: string }> }) => {
  return (
    <Box sx={{ mb: 4 }}>
      {breadcrumbs.map((crumb, index) => (
        <Box key={crumb.title} component="span">
          {crumb.uri ? (
            <Typography
              component="a"
              href={crumb.uri}
              variant="body.sm"
              sx={(theme) => ({
                "color": theme.palette["neutral.700"].main,
                "textDecoration": "none",
                "fontSize": "12px",
                "fontStyle": "normal",
                "fontWeight": 400,
                "lineHeight": "100%",
                "&:hover": {
                  textDecoration: "underline",
                },
                "&:visited": {
                  color: theme.palette["neutral.700"].main,
                },
              })}
            >
              {crumb.title}
            </Typography>
          ) : (
            <Typography
              component="span"
              variant="body.sm"
              sx={{
                color: "neutral.700.main",
              }}
            >
              {crumb.title}
            </Typography>
          )}
          {index < breadcrumbs.length - 1 && <BreadcrumbSeparator />}
        </Box>
      ))}
    </Box>
  )
}
